import { render, staticRenderFns } from "./PersonnelUserPerTable.vue?vue&type=template&id=c24d72b2"
import script from "./PersonnelUserPerTable.vue?vue&type=script&lang=js"
export * from "./PersonnelUserPerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports